import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTableFee extends Component<{ fee: string }> {
    render() {
        return <OptionalTableCell title='Appraisal Fee'>
            {this.props.fee}
        </OptionalTableCell>;
    }
}